import React from 'react';
import 'styles/global.css';
import 'styles/css/button.css';
import 'styles/css/normalize.css';
import 'styles/css/posts.css';
import 'styles/css/insta.css';
import 'styles/css/projects.css';
import 'styles/css/scroller.css';
import 'styles/css/scrum.css';
import 'styles/css/style.css';
import 'styles/css/bg.css';

import Footer from 'components/Codes/Footer';
import { Box } from '@mui/material';
import LightBox from '../components/Codes/LightBox';
import AppContext from '../provider/AppContext';
const LayoutWrap = ({ children, pageContext = {} }) => {
  if (pageContext?.layout === 'resume') {
    return <>{children}</>;
  }
  return (
    <Box sx={{ maxWidth: '1920px', margin: '0 auto' }}>
      <AppContext>
        {/* <Script
        src="https://cloud.umami.is/script.js"
        data-website-id="a5c235f5-6d99-4a46-8005-38667040d337"
      /> */}
        <LightBox />
        {children}
        <Footer />
      </AppContext>
    </Box>
  );
};

export default LayoutWrap;
